import { NgModule } from '@angular/core';
import { TrackingStoreModule } from './store';

@NgModule({
  imports: [TrackingStoreModule],
})
export class TrackingDataAccessModule {}
